import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useState } from 'react';
import useFetchTabConfig, { DEFAULT as DEFAULT$1 } from './useFetchTabConfig.js';
export { DEFAULT as DEFAULT_FETCH_CONFIG } from './useFetchTabConfig.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT = _objectSpread(_objectSpread({}, DEFAULT$1), {}, {
  app: '',
  aosBaseUrl: '',
  className: {},
  openMobileMenu: false,
  isSticky: false,
  isMobileView: false,
  translations: function translations(expression, params) {
    return expression || params;
  },
  customRouterChangeFunc: function customRouterChangeFunc() {},
  setOpenMobileMenu: function setOpenMobileMenu() {},
  onTabClick: undefined,
  containerName: '',
  vin: '',
  accountType: '',
  onLoadingEnd: function onLoadingEnd() {}
});
var useVehicleTabs = function useVehicleTabs() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    skip: false,
    translations: DEFAULT.translations,
    aosBaseUrl: DEFAULT.aosBaseUrl,
    app: DEFAULT.app,
    adfsToken: DEFAULT.adfsToken,
    className: DEFAULT.className,
    isSticky: DEFAULT.isSticky,
    onTabClick: DEFAULT.onTabClick,
    containerName: DEFAULT.containerName,
    vin: DEFAULT.vin,
    accountType: DEFAULT.accountType,
    onLoadingEnd: function onLoadingEnd() {}
  };
  var _props$skip = props.skip,
    skip = _props$skip === void 0 ? false : _props$skip,
    _props$translations = props.translations,
    translations = _props$translations === void 0 ? DEFAULT.translations : _props$translations,
    _props$aosBaseUrl = props.aosBaseUrl,
    aosBaseUrl = _props$aosBaseUrl === void 0 ? DEFAULT.aosBaseUrl : _props$aosBaseUrl,
    _props$app = props.app,
    app = _props$app === void 0 ? DEFAULT.app : _props$app,
    _props$adfsToken = props.adfsToken,
    adfsToken = _props$adfsToken === void 0 ? DEFAULT.adfsToken : _props$adfsToken,
    className = props.className,
    isSticky = props.isSticky,
    onTabClick = props.onTabClick,
    containerName = props.containerName,
    accountType = props.accountType,
    vin = props.vin,
    onLoadingEnd = props.onLoadingEnd;
  var fetchHook = useFetchTabConfig({
    skip: skip,
    accountType: accountType,
    vin: vin,
    aosBaseUrl: aosBaseUrl,
    app: app,
    adfsToken: adfsToken,
    onLoadingEnd: onLoadingEnd
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openMobileMenu = _useState2[0],
    setOpenMobileMenu = _useState2[1];
  return {
    app: app,
    className: className,
    navConfig: fetchHook.data,
    error: fetchHook.error,
    fetchNavConfig: fetchHook.fetch,
    loading: fetchHook.loading,
    openMobileMenu: openMobileMenu,
    aosBaseUrl: aosBaseUrl,
    isSticky: isSticky,
    onTabClick: onTabClick,
    translations: translations,
    setOpenMobileMenu: setOpenMobileMenu,
    containerName: containerName
  };
};

export { DEFAULT, useVehicleTabs as default };
